'use client';

import { useState } from 'react';
import ObjectViewer from 'components/collection/object-viewer';
import ErrorMessageBox from 'components/controls/error-message';
import SelectComponent from 'components/controls/select-component';
import { fetchObjectByAccessionNumber } from 'lib/collection/accessionLookup';
import { lofiArtworkObjectModel } from 'helpers/collection';
import pushToDataLayer from 'lib/analytics/pushToDataLayer';

const AccessionLookUpClient = ({ accessionNumbers, pageTitle }: Props) => {
	const accessionOptions = accessionNumbers?.map((accessionNumber) => {
		return { value: accessionNumber, label: accessionNumber };
	});
	const [error, setError] = useState(null);
	const [isSearching, setIsSearching] = useState(false);
	const [activeObject, setActiveObject] = useState(null);

	const clearError = () => setError(null);

	const logAndSetError = () => {
		const error = 'Something went wrong! Try again.';
		console.error('error:', error);
		setError(error);
	};

	const callSearchAPI = async (query) => {
		setIsSearching(true);
		const formattedQuery = query.trim();
		const object = await fetchObjectByAccessionNumber(formattedQuery);
		setIsSearching(false);

		if (!object) {
			logAndSetError();
			return;
		}
		clearError();
		setActiveObject(object);

		const analyticsData = {
			event: 'search_accession',
			Content_Type: 'Gallery Viewer',
			Content_Name: pageTitle,
			Object_Title: object.titles?.primary.title,
			Object_ID: object.objectID,
			Accession_Number: object.accessionNumber,
		};

		pushToDataLayer(analyticsData);
	};

	const handleSelect = async (e) => {
		const query = e.value;
		await callSearchAPI(query);
	};

	return (
		<div style={{ minWidth: '250px' }}>
			<div style={isSearching ? { opacity: 0.2 } : null}>
				<SelectComponent
					menuPlacement="auto"
					placeholder="Enter accession number"
					showFieldName={false}
					id={`accessionNumberLookUp`}
					fieldName="Accession Number Look Up"
					options={accessionOptions}
					onChange={handleSelect}
					value={
						activeObject
							? {
									value: activeObject.accessionNumber,
									label: activeObject.accessionNumber,
								}
							: null
					}
				/>
				{error && <ErrorMessageBox message={error} />}
			</div>

			{activeObject && (
				<ObjectViewer
					packageID={null}
					objects={[lofiArtworkObjectModel(activeObject)]}
					initialActiveObjectIndex={0}
					handleCloseClick={() => setActiveObject(null)}
				/>
			)}
		</div>
	);
};

interface Props {
	accessionNumbers: any[];
	pageTitle: string;
}

export default AccessionLookUpClient;
